
import React from 'react'; 
import { useState } from 'react';
import { TabMenu } from 'primereact/tabmenu';
import { useSearchParams } from "react-router-dom";
import { Tooltip } from 'primereact/tooltip';

export default function BasicDemo({setRankingTypeFn}) {

    const [searchParams, setSearchParams] = useSearchParams();

    const rankingTypes = ['regular', 'pro', 'elite'];

    const chosenRankingType = searchParams.get("rankingType");
    const chosenRankingTypeIndex = rankingTypes.indexOf(chosenRankingType)  < 0 ? 0 : rankingTypes.indexOf(chosenRankingType);
    const [activeIndex, setActiveIndex] = useState(chosenRankingTypeIndex);

    const items = [
        { label: <span><Tooltip target={`.tab-regular`} mouseTrack mouseTrackLeft={10}/><span className="tab-regular" data-pr-tooltip={`Top ~25% ranked players`} >Regular</span></span>, icon: 'pi pi-map-marker' },
        { label: <span><Tooltip target={`.tab-pro`} mouseTrack mouseTrackLeft={10}/><span className="tab-pro" data-pr-tooltip={`Top 100 ranked players`} data-pr-position="top">Pro</span></span>, icon: 'pi pi-chart-line' },
        { label: <span><Tooltip target={`.tab-elite`} mouseTrack mouseTrackLeft={10}/><span className="tab-elite" data-pr-tooltip={`Top 30 ranked players`} data-pr-position="top">Elite</span></span>, icon: 'pi pi-crown' }
    ];

    return (
        <div className="card">
            <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => {setActiveIndex(e.index); setRankingTypeFn(rankingTypes[e.index]); setSearchParams({...searchParams, rankingType: rankingTypes[e.index]})}} />
        </div>
    )
}
        